import { render, staticRenderFns } from "./TokenDistributionChart.vue?vue&type=template&id=2d1f2944&"
import script from "./TokenDistributionChart.vue?vue&type=script&lang=js&"
export * from "./TokenDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports